import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../Menu.css"; // Import the custom CSS
import { logout } from "../redux/actions/authAction";

const Adminnavbar = () => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	const { auth } = useSelector((state) => state);
	const dispatch = useDispatch();
	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
	const [dropdownOpen, setDropdownOpen] = useState(null);

	const mobileMenuRef = useRef(null);
	const mobileMenuOverlayRef = useRef(null);

	const toggleMobileMenu = () => {
		setMobileMenuOpen(!mobileMenuOpen);
	};

	const toggleDropdown = (index) => {
		setDropdownOpen(dropdownOpen === index ? null : index);
	};
	const notifications = [
		{
			id: "1",
			massage: "you got one notification",
		},
		{
			id: "2",
			massage: "you got one notification",
		},
		{
			id: "3",
			massage: "you got one notification",
		},
		{
			id: "4",
			massage: "you got one notification",
		},
	];

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth > 1112 && mobileMenuOpen) {
				setMobileMenuOpen(false);
			}
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, [mobileMenuOpen]);

	useEffect(() => {
		if (mobileMenuOpen) {
			document.body.style.overflow = "hidden";
			document.documentElement.style.overflow = "hidden"; // add this
		} else {
			document.body.style.overflow = "";
			document.documentElement.style.overflow = ""; // and reset it here
		}
	}, [mobileMenuOpen]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			// Check if the click was outside the mobile menu and overlay
			if (
				mobileMenuRef.current &&
				!mobileMenuRef.current.contains(event.target) && // Click outside the menu
				!mobileMenuOverlayRef.current.contains(event.target) // Click outside the overlay
			) {
				setMobileMenuOpen(false); // Close the menu
			}
		};

		if (mobileMenuOpen) {
			document.addEventListener("mousedown", handleClickOutside); // Listen for outside clicks
		} else {
			document.removeEventListener("mousedown", handleClickOutside); // Cleanup
		}

		return () => {
			document.removeEventListener("mousedown", handleClickOutside); // Cleanup on unmount
		};
	}, [mobileMenuOpen]);

	return (
		<div className="admin-navbar-wrapper">
			<div className="menu-bar v2">
				{/* Menu Bar Start */}
				<div>
					<div>
						<div
							className="menu-bar-content"
							style={{ justifyContent: "space-around" }}>
							{/* Logo Section */}
							<div className="menu-logo">
								<a href="/">
									<img
										href="/"
										src="../images/LOGO.png"
										alt="logo"
										height={100}
									/>
								</a>

								<div className="logo-text-container">
									<span className="logo-divider"></span>
									<a
										className="logo-text nav-links"
										href="/"
										style={{ padding: "0" }}>
										GLOBAL ACADEMY <br /> FOR FOOD SAFETY AND <br />
										SUSTAINABLE STANDARDS
									</a>
								</div>
							</div>

							{/* Navigation Menu */}
							<nav className="main-menu">
								<ul className="menu-list">
									<li className="menu-item nav-item">
										<a title="Home" href="/home" className="nav-links">
											Home
										</a>
									</li>
									{/* <li className="menu-item nav-item">
                  <div id="" >
                    <div className="nav-links" onClick={handleShow}>
                      Notifications
                    </div>
                    <div id="">
                      <Modal
                        id="modalviewer"
                        show={show}
                        onHide={handleClose}
                        style={{ margin: "0", float: "inline-end" }}
                      >
                        <div
                          className="x-style1"
                          onClick={handleClose}
                          style={{ fontSize: "" }}
                        >
                          {" "}
                          <span style={{ cursor: "pointer" }}>X</span>
                        </div>
                        <div id="modalsetup" className="js-boxIn">
                          <div className="js-boxIn-content">
                            <div className="ai-greenbox1">
                              <div>
                                <h4 className="js-greenbox-heading">
                                  Notifications
                                </h4>
                              </div>
                              <div id="notifyalign" className="col">
                                <div >
                                  {notifications.map((k) => {
                                    return (
                                      <>
                                        <div className="notifyfont">
                                          {k.massage}
                                        </div>
                                        <hr />
                                      </>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <a href="/allnotifications" alt="">
                          <div
                            className="notifyviewall"
                            style={{ padding: "10px 0px" }}
                          >
                            {" "}
                            View All
                          </div>
                        </a>
                      </Modal>
                    </div>
                  </div>
                </li> */}

									<li className="menu-item nav-item">
										{auth.user === undefined ? (
											<a title="Log In" href="/login" className="nav-links">
												<i
													className="fa fa-user"
													aria-hidden="true"
													style={{ marginRight: "8px" }}></i>
												Log In
											</a>
										) : (
											<>
												<a
													title="Logout"
													href="/login"
													onClick={() => dispatch(logout())}
													className="nav-links">
													<i
														className="fa fa-sign-out"
														aria-hidden="true"
														style={{ marginRight: "8px" }}></i>
													Logout
												</a>
											</>
										)}
									</li>
								</ul>
							</nav>

							{/* Mobile Menu Button */}
							<button
								className="mobile-menu-btn"
								onClick={toggleMobileMenu}
								aria-label="Toggle mobile menu">
								<span
									style={{
										height: "2px",
										width: "100%",
										background: "#000",
									}}></span>
								<span
									style={{
										height: "2px",
										width: "100%",
										background: "#000",
									}}></span>
								<span
									style={{
										height: "2px",
										width: "100%",
										background: "#000",
									}}></span>
							</button>

							{/* Mobile Menu */}
							{mobileMenuOpen && (
								<div className="mobile-menu" ref={mobileMenuRef}>
									<div className="mobile-header">
										{/* <div className="mobile-logo">
											<a
											  className="standard-logo"
											  href="https://digitalvega.in/foodsafetyacademy/"
											>
											  <img
												src="https://digitalvega.in/foodsafetyacademy/wp-content/uploads/2024/10/main-logo-1.png"
												alt="logo"
											  />
											</a>
										  </div> */}
										<button
											className="mobile-menu-btn"
											onClick={toggleMobileMenu}
											style={{
												fontSize: "24px",
												fontWeight: "bold",
												background: "none",
												border: "none",
												cursor: "pointer",
												color: "#000",
												marginBottom: "12px",
											}}>
											{/* <span className="my-icon icon-angle-arrow-left"></span> */}
											{/* <span
											  style={{
												height: "2px",
												width: "100%",
												background: "#000",
											  }}
											></span>
											<span
											  style={{
												height: "2px",
												width: "100%",
												background: "#000",
											  }}
											></span>
											<span
											  style={{
												height: "2px",
												width: "100%",
												background: "#000",
											  }}
											></span> */}
											x
										</button>
									</div>
									<div className="mobile-overflow">
										<nav className="main-manu">
											{/* <ul id="menu-our-menu">
											  <li className="menu-item nav-item">
												<a
												  title="Home"
												  href="https://digitalvega.in/foodsafetyacademy/home/"
												  className="nav-links"
												>
												  Home
												</a>
											  </li>
											</ul> */}
											<ul className="menu-list">
												<li className="menu-item nav-item">
													<a title="Home" href="/home" className="nav-links">
														Home
													</a>
												</li>
												<li className="menu-item nav-item">
													{auth.user === undefined ? (
														<a
															title="Log In"
															href="/login"
															className="nav-links">
															<i
																className="fa fa-user"
																aria-hidden="true"
																style={{ marginRight: "8px" }}></i>
															Log In
														</a>
													) : (
														<>
															<a
																title="Logout"
																href="/login"
																onClick={() => dispatch(logout())}
																className="nav-links">
																<i
																	className="fa fa-sign-out"
																	aria-hidden="true"
																	style={{ marginRight: "8px" }}></i>
																Logout
															</a>
														</>
													)}
												</li>
											</ul>
										</nav>
									</div>
								</div>
							)}
							<div
								className={`mobile-menu-overlay ${
									mobileMenuOpen ? "show" : ""
								}`}
								ref={mobileMenuOverlayRef}
								onClick={() => setMobileMenuOpen(false)}></div>
						</div>
					</div>
				</div>
				{/* Menu Bar End */}
			</div>
		</div>
	);
};

export default Adminnavbar;
